import { render, staticRenderFns } from "./SlotModal.vue?vue&type=template&id=c6149366"
import script from "./SlotModal.vue?vue&type=script&lang=js"
export * from "./SlotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports